import { Box, Stack, Typography } from "@mui/material";
import { Colors } from "@src/gatsby-theme-material-ui-top-layout/colors-twentyfive-dark";
import React, { FC } from "react";
import { Link } from "gatsby-theme-material-ui";

interface Props {
  result: any;
}

const SearchResult: FC<Props> = ({ result }) => {
  return (
    <Link
      to={`#${
        result?.doc?.type === "example"
          ? result?.doc?.categoryIds?.[0]
          : result?.id
      }`}
      data-testid="pit-toolbar-search-result"
      sx={{
        position: "relative",
        width: "100%",
        border: "solid 1px #FFFFFF10",
        borderRadius: "15px",
        padding: "12px",
        "&:hover": {
          border: "solid 1px #FFFFFF50",
          opacity: 1,
        },
        "&:active, &:visited": {
          border: "solid 1px #FFFFFF10",
        },
        backdropFilter: "blur(5px)",
        backgroundColor: "#00000095",
      }}
    >
      <Stack
        sx={{
          flexDirection: "row",
          gap: "6px",
        }}
      >
        <Typography
          variant="caption"
          sx={{
            color: Colors.InfoMain,
          }}
        >
          {result?.doc?.type?.toUpperCase()}
        </Typography>{" "}
        {result?.doc?.type === "example" && (
          <Typography
            variant="body2"
            sx={{
              fontWeight: 600,
              opacity: 0.7,
              fontSize: "16px",
            }}
          >
            ({result?.doc?.id})
          </Typography>
        )}
      </Stack>

      {result?.doc?.type === "category" && (
        <Typography
          variant="body2"
          sx={{
            fontSize: "16px",
            fontWeight: 500,
          }}
        >
          {result?.doc?.title}{" "}
          <Box
            component="span"
            sx={{
              opacity: 0.7,
            }}
          >
            ({result?.doc?.id})
          </Box>
        </Typography>
      )}

      <Typography
        variant="body2"
        sx={{
          fontSize: "16px",
          color: Colors.BodyText,
        }}
      >
        {result?.doc?.description.substring(0, 250)}
        {result?.doc?.description?.length > 250 && "..."}
      </Typography>
    </Link>
  );
};

export default SearchResult;
